import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
	aurCommissionListingDataThunk,
	fetchOrderTreeDataThunk,
	fetchReferralCommissionDataThunk,
	fetchReferralCommissionTeamViewDataThunk,
	sponserCommissionListingDataThunk,
} from './myEarningsThunk'

const initialState = {
	referralCommissionsData: [],
	referralTotal: 0,
	referralCommissionsTeamViewData: [],
	referralTeamViewTotal: 0,
	orderTreeData: [],
	sponserCommissionsData: [],
	sponserTotal: 0,
	aurCommissionsData: [],
	aurTotal: 0,
}

export const getReferralCommissionsData = createAsyncThunk('users/getReferralCommissionsData', fetchReferralCommissionDataThunk)
export const getSponserCommissionsData = createAsyncThunk('users/getSponserCommissionsData', sponserCommissionListingDataThunk)
export const getAURCommissionsData = createAsyncThunk('users/getAURCommissionsData', aurCommissionListingDataThunk)
export const fetchReferralCommissionTeamViewData = createAsyncThunk(
	'users/fetchReferralCommissionTeamViewData',
	fetchReferralCommissionTeamViewDataThunk
)

export const fetchOrderTreeData = createAsyncThunk('users/fetchOrderTreeData', fetchOrderTreeDataThunk)

const myEarningsSlice = createSlice({
	name: 'myEarnings',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(getReferralCommissionsData.fulfilled, (state, action) => {
			state.referralCommissionsData = action?.payload?.data
			state.referralTotal = action?.payload?.total
			state.orderProcessingStatus = action?.payload?.orderProcessingStatus
		})
		builder.addCase(getSponserCommissionsData.fulfilled, (state, action) => {
			state.sponserCommissionsData = action?.payload?.data
			state.sponserTotal = action?.payload?.total
		})
		builder.addCase(getAURCommissionsData.fulfilled, (state, action) => {
			state.aurCommissionsData = action?.payload?.data
			state.aurTotal = action?.payload?.total
			state.orderProcessingStatus = action?.payload?.orderProcessingStatus
		})
		builder.addCase(fetchReferralCommissionTeamViewData.fulfilled, (state, action) => {
			state.referralCommissionsTeamViewData = action?.payload?.data
			state.referralTeamViewTotal = action?.payload?.data?.total
		})

		builder.addCase(fetchOrderTreeData.fulfilled, (state, action) => {
			state.orderTreeData = action?.payload?.data
		})
	},
})

// export const { } = cartSlice.actions

export default myEarningsSlice.reducer
